import React, { createContext, useContext, useState } from 'react';

interface BrandProductsFilterState {
  searchFilter: string;
  statusFilter: string;
  typeFilter: string;
  categoryFilter: string;
  subcategoryFilter: string;
  selectedTags: string[];
  selectedMoreTags: string[];
  selectedTag3: string[];
  currentPage: number;
}

interface BrandProductsFilterContextType extends BrandProductsFilterState {
  setSearchFilter: (v: string) => void;
  setStatusFilter: (v: string) => void;
  setTypeFilter: (v: string) => void;
  setCategoryFilter: (v: string) => void;
  setSubcategoryFilter: (v: string) => void;
  setSelectedTags: React.Dispatch<React.SetStateAction<string[]>>;
  setSelectedMoreTags: React.Dispatch<React.SetStateAction<string[]>>;
  setSelectedTag3: React.Dispatch<React.SetStateAction<string[]>>;
  setCurrentPage: (v: number) => void;
}

const BrandProductsFilterContext = createContext<BrandProductsFilterContextType | undefined>(undefined);

export const BrandProductsFilterProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [searchFilter, setSearchFilter] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [typeFilter, setTypeFilter] = useState('all');
  const [categoryFilter, setCategoryFilter] = useState('all');
  const [subcategoryFilter, setSubcategoryFilter] = useState('all');
  const [selectedTags, setSelectedTags] = useState<string[]>([]);
  const [selectedMoreTags, setSelectedMoreTags] = useState<string[]>([]);
  const [selectedTag3, setSelectedTag3] = useState<string[]>([]);
  const [currentPage, setCurrentPage] = useState(1);

  return (
    <BrandProductsFilterContext.Provider
      value={{
        searchFilter, setSearchFilter,
        statusFilter, setStatusFilter,
        typeFilter, setTypeFilter,
        categoryFilter, setCategoryFilter,
        subcategoryFilter, setSubcategoryFilter,
        selectedTags, setSelectedTags,
        selectedMoreTags, setSelectedMoreTags,
        selectedTag3, setSelectedTag3,
        currentPage, setCurrentPage,
      }}
    >
      {children}
    </BrandProductsFilterContext.Provider>
  );
};

export const useBrandProductsFilter = () => {
  const context = useContext(BrandProductsFilterContext);
  if (!context) {
    throw new Error('useBrandProductsFilter must be used within BrandProductsFilterProvider');
  }
  return context;
};
